/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Send_Test_AddressInputs */

const en_error_crm_send_test_address = /** @type {(inputs: Error_Crm_Send_Test_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A test email goes to Tomorrow's addresses only.`)
};

/**
* | output |
* | --- |
* | "A test email goes to Tomorrow's addresses only." |
*
* @param {Error_Crm_Send_Test_AddressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_send_test_address = /** @type {((inputs?: Error_Crm_Send_Test_AddressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Send_Test_AddressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_send_test_address(inputs)
});